export default __webpack_public_path__ + "static/downloadSection-043d98e56d1a773a2369d2c584514f08.webm";